const DRIVER_TYPE = 'DRIVER';
const APPLICANT_TYPES = {
  APPLICANT: 'APPLICANT',
  CO_APPLICANT: 'CO_APPLICANT',
  CO_SIGNER: 'CO_SIGNER',
  DRIVER: DRIVER_TYPE
};

const ADDRESS_TYPES = {
  INSURE: 'INSURE',
  MAILING: 'MAILING',
  BILLING: 'BILLING',
  RESIDENCE: 'RESIDENCE',
  PREVIOUS_RESIDENCE: 'PREVIOUS_RESIDENCE',
  DRIVER_ADDRESS: 'DRIVER_ADDRESS',
  GARAGE_ADDRESS: 'GARAGE_ADDRESS'
};

const GENDER = {
  MALE: 'MALE',
  FEMALE: 'FEMALE'
};

const RELATIONSHIPS = {
  SPOUSE: 'SPOUSE',
  PARENT: 'PARENT',
  CHILD: 'CHILD',
  DOMESTIC_PARTNER: 'DOMESTIC PARTNER',
  RELATIVE: 'RELATIVE',
  EMPLOYEE: 'EMPLOYEE',
  SELF: 'SELF',
  FRIEND: 'FRIEND',
  LIENHOLDER: 'LIENHOLDER',
  OTHER_FAMILY: 'OTHER_FAMILY',
  OTHER: 'OTHER'
};

const DEFAULT_RELATIONSHIP = RELATIONSHIPS.SELF;

const MARITAL_STATUSES = {
  SINGLE: 'SINGLE',
  MARRIED: 'MARRIED',
  DOMESTIC_PARTNER: 'DOMESTIC_PARTNER',
  SEPARATED: 'SEPARATED',
  WIDOWED: 'WIDOWED',
  DIVORCED: 'DIVORCED'
};

const PHONE_TYPES = {
  MOBILE: 'MOBILE',
  HOME: 'HOME',
  WORK: 'WORK',
  FAX: 'FAX',
  OTHER: 'OTHER'
};

const DWELLING_TYPES = {
  SINGLE_FAMILY: 'SINGLE_FAMILY',
  MULTI_FAMILY: 'MULTI_FAMILY',
  MOBILE: 'MOBILE',
  MODULAR: 'MODULAR',
  DUPLEX: 'DUPLEX',
  CONNECTED_END: 'CONNECTED_END',
  CONNECTED_MID: 'CONNECTED_MID',
  CONNECTED: 'CONNECTED',
  UNKNOWN: 'UNKNOWN',
  ROW_HOME: 'ROW_HOME',
  // For Renter's applications
  CONDO: 'CONDO',
  APARTMENT: 'APARTMENT',
  CO_OP: 'CO-OP',
  HOUSE: 'HOUSE'
};

const PROPERTY_TYPES = {
  PRIMARY_RESIDENCE: 'PRIMARY_RESIDENCE',
  SECONDARY_RESIDENCE: 'SECONDARY_RESIDENCE',
  RENTAL_PROPERTY: 'RENTAL_PROPERTY',
  VACANT: 'VACANT',
  LAND_ONLY: 'LAND_ONLY'
};

const EDUCATION = {
  NO_DIPLOMA: 'No Diploma',
  HIGH_SCHOOL: 'High School',
  SOME_COLLEGE: 'Some College',
  VOCATIONAL_TECHNICAL: 'Vocational/Technical',
  ASSOCIATES: "Associate's",
  BACHELORS: "Bachelor's",
  MASTERS: "Master's",
  DOCTORATE: 'Doctorate',
  DOCTORATE_LAW: 'Doctorate - Law',
  DOCTORATE_MEDICAL: 'Doctorate - Medical'
};

const DONT_KNOW = "Don't know";

const NEVER = 'Never';

const RESIDENCE_TYPES = {
  OWN_A_HOME: 'OWN_A_HOME',
  OWN_A_CONDO: 'OWN_A_CONDO',
  RENTING_A_HOME: 'RENTING_A_HOME',
  RENTING_A_CONDO: 'RENTING_A_CONDO',
  RENTING_AN_APARTMENT: 'RENTING_AN_APARTMENT',
  LIVING_WITH_PARENTS_OR_FAMILY: 'LIVING_WITH_PARENTS_OR_FAMILY',
  OTHER: 'OTHER'
};

const PLUMBING_TYPES = [
  'Entirely copper',
  'Entirely galvanized',
  'Entirely PEX',
  'Entirely PVC',
  'Polybutylene',
  'Mix of the above materials',
  'Mix of materials above and other non-listed materials',
  'Other non-listed materials'
];

const HOME_BUSINESS_TYPES = {
  HOME_OFFICE: 'HOME_OFFICE',
  CLIENT_APPOINTMENTS: 'CLIENT_APPOINTMENTS',
  LONG_TERM_ROOM_RENTAL: 'LONG_TERM_ROOM_RENTAL',
  SHORT_TERM_ROOM_RENTAL: 'SHORT_TERM_ROOM_RENTAL',
  BED_AND_BREAKFAST: 'BED_AND_BREAKFAST',
  DAY_CARE: 'DAY_CARE',
  DOMESTIC_WORKERS: 'DOMESTIC_WORKERS',
  ANIMAL_RELATED: 'ANIMAL_RELATED',
  FARMING_LIVESTOCK_RELATED: 'FARMING_LIVESTOCK_RELATED',
  OTHER: 'OTHER'
};

const DOG_BREEDS = {
  AKITA: 'AKITA',
  CHOW: 'CHOW',
  DOBERMAN: 'DOBERMAN',
  PITBULL: 'PITBULL',
  STAFFORDSHIRE_BULL_TERRIER: 'STAFFORDSHIRE_BULL_TERRIER',
  ROTTWEILER: 'ROTTWEILER',
  PRESA_CANARIOS: 'PRESA_CANARIOS',
  WOLF_HYBRID: 'WOLF_HYBRID',
  MIX: 'MIX',
  OTHER: 'OTHER'
};

const ANIMALS = {
  CATS: 'CATS',
  DOGS: 'DOGS',
  EXOTIC: 'EXOTIC',
  FARM: 'FARM'
};

const LICENSE_STATUS_OPTIONS = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  PERMIT: 'PERMIT',
  SUSPENDED: 'SUSPENDED',
  FOREIGN: 'FOREIGN'
};

const YEARS_INSURED = {
  ZERO: 'ZERO',
  ZERO_TO_SIX_MONTHS: 'ZERO_TO_SIX_MONTHS',
  SIX_TO_TWELVE_MONTHS: 'SIX_TO_TWELVE_MONTHS',
  ONE_TO_TWO_YEARS: 'ONE_TO_TWO_YEARS',
  TWO_TO_THREE_YEARS: 'TWO_TO_THREE_YEARS',
  THREE_TO_FOUR_YEARS: 'THREE_TO_FOUR_YEARS',
  FOUR_TO_FIVE_YEARS: 'FOUR_TO_FIVE_YEARS',
  FIVE_TO_SIX_YEARS: 'FIVE_TO_SIX_YEARS',
  SIX_TO_SEVEN_YEARS: 'SIX_TO_SEVEN_YEARS',
  SEVEN_PLUS_YEARS: 'SEVEN_PLUS_YEARS'
};

const ALARM_SIGNAL_TYPES = {
  NONE: 'NONE',
  LOCAL: 'LOCAL',
  DIRECT: 'DIRECT',
  CENTRAL: 'CENTRAL'
};

const STORM_PROTECTIONS = ['SHUTTERS', 'WINDOWS', 'DOORS', 'SCREENS'];

const PROPERTY_INCIDENT_DESCS = {
  CONTAMINATION: 'CONTAMINATION',
  CREDIT_CARD: 'CREDIT_CARD',
  DAMAGE_TO_PROPERTY_OF_OTHERS: 'DAMAGE_TO_PROPERTY_OF_OTHERS',
  DOG_BITE_WITH_LIABILITY: 'DOG_BITE_WITH_LIABILITY',
  EARTH_MOVEMENT: 'EARTH_MOVEMENT',
  EARTHQUAKE: 'EARTHQUAKE',
  EXTENDED_COVERAGE_PERILS: 'EXTENDED_COVERAGE_PERILS',
  FIRE: 'FIRE',
  FLOOD: 'FLOOD',
  FREEZING_WATER_INCLUDING_BURST_PIPES: 'FREEZING_WATER_INCLUDING_BURST_PIPES',
  HAIL: 'HAIL',
  LIGHTNING: 'LIGHTNING',
  MEDICAL_PAYMENTS: 'MEDICAL_PAYMENTS',
  MYSTERIOUS_DISAPPEARANCE: 'MYSTERIOUS_DISAPPEARANCE',
  MYSTERIOUS_DISAPPEARANCE_SCHEDULED_PRPPERTY: 'MYSTERIOUS_DISAPPEARANCE_SCHEDULED_PRPPERTY',
  SLIP_FALL: 'SLIP_FALL',
  SMOKE: 'SMOKE',
  THEFT_BURGLARY: 'THEFT_BURGLARY',
  THEFT_SCHEDULED_PROPERTY: 'THEFT_SCHEDULED_PROPERTY',
  VANDALISM_MISCHIEF: 'VANDALISM_MISCHIEF',
  WATER_DAMAGE: 'WATER_DAMAGE',
  WATERCRAFT: 'WATERCRAFT',
  WIND: 'WIND',
  WORKERS_COMPENSATION: 'WORKERS_COMPENSATION',
  OTHER_WITHOUT_LIABILITY: 'OTHER_WITHOUT_LIABILITY',
  OTHER_WITH_LIABILITY: 'OTHER_WITH_LIABILITY'
};

const INCIDENT_TYPES = {
  ACCIDENT: 'ACCIDENT',
  CLAIM: 'CLAIM',
  VIOLATION: 'VIOLATION'
};

const CLAIM_DESCRIPTIONS = {
  FIRE: 'FIRE',
  THEFT: 'THEFT',
  TOWING: 'TOWING',
  VANDALISM: 'VANDALISM',
  GLASS: 'GLASS',
  HIT_ANIMAL: 'HIT_ANIMAL',
  TORNADO_OR_HURRICANE: 'TORNADO_OR_HURRICANE',
  FLOOD: 'FLOOD',
  WIND_OR_HALE: 'WIND_OR_HALE',
  OTHER: 'OTHER'
};

const VIOLATION_DESCRIPTIONS = {
  CARELESS_DRIVING: 'CARELESS_DRIVING',
  DEFECTIVE_EQUIPMENT: 'DEFECTIVE_EQUIPMENT',
  DRIVING_ON_SUSPENDED_LICENSE: 'DRIVING_ON_SUSPENDED_LICENSE',
  DUI: 'DUI',
  FAILURE_TO_OBEY_SIGNAL: 'FAILURE_TO_OBEY_SIGNAL',
  SPEEDING_1_TO_5_MPH_OVER: 'SPEEDING_1_TO_5_MPH_OVER',
  SPEEDING_6_TO_10_MPH_OVER: 'SPEEDING_6_TO_10_MPH_OVER',
  SPEEDING_11_TO_15_MPH_OVER: 'SPEEDING_11_TO_15_MPH_OVER',
  SPEEDING_16_TO_20_MPH_OVER: 'SPEEDING_16_TO_20_MPH_OVER',
  SPEEDING_21_PLUS_MPH_OVER: 'SPEEDING_21_PLUS_MPH_OVER',
  SPEEDING_MAJOR_VIOLATION: 'SPEEDING_MAJOR_VIOLATION',
  SPEEDING_MINOR_VIOLATION: 'SPEEDING_MINOR_VIOLATION',
  OTHER_MAJOR_VIOLATION: 'OTHER_MAJOR_VIOLATION',
  OTHER_MINOR_VIOLATION: 'OTHER_MINOR_VIOLATION',
  TICKET_VIOLATION_NOT_LISTED: 'TICKET_VIOLATION_NOT_LISTED'
};

const ACCIDENT_DESCRIPTIONS = {
  AT_FAULT_WITH_INJURY: 'AT_FAULT_WITH_INJURY',
  AT_FAULT_NO_INJURY: 'AT_FAULT_NO_INJURY',
  NOT_AT_FAULT: 'NOT_AT_FAULT'
};

const VEHICLE_OWNERSHIP_STATUS = {
  OWNED: 'OWNED',
  LOANED: 'LOANED',
  LEASED: 'LEASED'
};

const VEHICLE_ACTIVITES = ['RIDE_SHARE', 'FOOD_DELIVERY'];

const VEHICLE_USES = {
  COMMUTE: 'COMMUTE',
  BUSINESS: 'BUSINESS',
  PLEASURE: 'PLEASURE',
  RIDE_SHARE: 'RIDE_SHARE'
};

const DRIVER_USAGE = {
  RARELY: 'RARELY',
  FREQUENTLY: 'FREQUENTLY',
  SOMETIMES: 'SOMETIMES'
};

const HEATING_SOURCES = {
  ELECTRIC: 'ELECTRIC',
  GAS: 'GAS',
  GAS_FORCED_AIR: 'GAS_FORCED_AIR',
  GAS_HOT_WATER: 'GAS_HOT_WATER',
  OIL: 'OIL',
  OIL_FORCED_AIR: 'OIL_FORCED_AIR',
  OIL_HOT_WATER: 'OIL_HOT_WATER',
  SOLID_FUEL: 'SOLID_FUEL',
  OTHER: 'OTHER'
};

const PREFERRED_COMMUNICATION_METHODS = {
  PRIMARY_PHONE: 'PRIMARY_PHONE',
  PRIMARY_EMAIL: 'PRIMARY_EMAIL',
  SMS: 'SMS'
};

const FOUNDATION_TYPES = {
  BASEMENT: 'BASEMENT',
  CRAWL_SPACE: 'CRAWL_SPACE',
  SLAB: 'SLAB',
  OPEN_RAISED: 'OPEN_RAISED'
};

const CONSTRUCTION_TYPES = {
  FRAME: 'FRAME',
  MASONRY: 'MASONRY',
  LOG: 'LOG', // 'Log Home'
  JOISTED: 'JOISTED', // 'Joisted Masonry',
  MASONRY_VENEER: 'MASONRY_VENEER', // 'Masonry Veneer',
  MODIFIED: 'MODIFIED', // 'Modified Fire Resistive',
  FIRE: 'FIRE', // 'Fire Resistive/Superior',
  SUPERIOR: 'SUPERIOR', // 'Superior Non Combustible',
  STUCCO: 'STUCCO', // 'Stucco',
  METAL: 'METAL', // 'Metal/Aluminum Siding',
  CONCRETE: 'CONCRETE', // 'Concrete',
  STEEL: 'STEEL', // 'Steel',
  MOBILE: 'MOBILE' // 'Mobile Home',
};

const ROOF_TYPES = {
  ALUMINUM: 'ALUMINUM',
  ARCHITECTURAL_SHINGLE: 'ARCHITECTURAL_SHINGLE',
  ASBESTOS: 'ASBESTOS',
  ASPHALT_SHINGLES: 'ASPHALT_SHINGLES',
  BERMUDA: 'BERMUDA',
  BUILT_UP: 'BUILT_UP',
  COMPOSITION_SHINGLE: 'COMPOSITION_SHINGLE',
  CONCRETE: 'CONCRETE',
  FIBERGLASS: 'FIBERGLASS',
  GRAVEL_OR_ROCK: 'GRAVEL_OR_ROCK',
  GYPSUM: 'GYPSUM',
  HAIL_PROOF_SHINGLE: 'HAIL_PROOF_SHINGLE',
  MASONITE_OR_CEMENT_SHAKE: 'MASONITE_OR_CEMENT_SHAKE',
  METAL: 'METAL',
  NON_WOOD_SHINGLES: 'NON_WOOD_SHINGLES',
  ROLL_COMPOSITION: 'ROLL_COMPOSITION',
  SLATE: 'SLATE',
  STEEL: 'STEEL',
  TAR_AND_GRAVEL: 'TAR_AND_GRAVEL',
  TILE: 'TILE',
  URETHANE: 'URETHANE',
  WOOD: 'WOOD',
  WOOD_SHAKE_OR_SHINGLES: 'WOOD_SHAKE_OR_SHINGLES',
  OTHER: 'OTHER'
};

const ROOF_SHAPES = {
  BOWSTRING_TRUSS: 'BOWSTRING_TRUSS',
  CATHEDRAL: 'CATHEDRAL',
  DOME: 'DOME',
  FLAT: 'FLAT',
  GABLE: 'GABLE',
  GABLE_OR_HIP: 'GABLE_OR_HIP',
  GAMBREL: 'GAMBREL',
  HIP: 'HIP',
  MANSARD: 'MANSARD',
  PRESTRESS_CONCRETE: 'PRESTRESS_CONCRETE',
  REINFORCED_CONCRETE: 'REINFORCED_CONCRETE',
  RIGID_FRAME_BAR_JOIST: 'RIGID_FRAME_BAR_JOIST',
  SAWTOOTH: 'SAWTOOTH',
  SHED: 'SHED',
  STEEL_FRAME_OR_TRUSS: 'STEEL_FRAME_OR_TRUSS',
  WOOD_TRUSS: 'WOOD_TRUSS',
  OTHER: 'OTHER'
};

const EXTERIOR_WALL_MATERIALS = {
  ADOBE: 'ADOBE',
  ADOBE_BRICK: 'ADOBE_BRICK',
  ADOBE_WITH_STUCCO: 'ADOBE_WITH_STUCCO',
  ALUMINUM: 'ALUMINUM',
  BARN_PLANK: 'BARN_PLANK',
  BRICK: 'BRICK',
  BRICK_IMITATION: 'BRICK_IMITATION',
  BROWNSTONE: 'BROWNSTONE',
  CEMENT_FIBER: 'CEMENT_FIBER',
  CLAPBOARD: 'CLAPBOARD',
  CLAPBOARD_REDWOOD: 'CLAPBOARD_REDWOOD',
  CLAY_TILE_WITH_BACKUP: 'CLAY_TILE_WITH_BACKUP',
  CONCRETE_BLOCK: 'CONCRETE_BLOCK',
  CONCRETE_BLOCK__DECORATIVE: 'CONCRETE_BLOCK__DECORATIVE',
  CONCRETE_POUREDINPLACE_4_TO_6: 'CONCRETE_POUREDINPLACE_4_TO_6',
  CONCRETE_POUREDINPLACE_7_TO_10: 'CONCRETE_POUREDINPLACE_7_TO_10',
  EIFS: 'EIFS',
  FIELDSTONE: 'FIELDSTONE',
  GLASS_BLOCK: 'GLASS_BLOCK',
  GRANITE: 'GRANITE',
  HALFTIMBER_AND_BRICK: 'HALFTIMBER_AND_BRICK',
  HALFTIMBER_AND_STUCCO: 'HALFTIMBER_AND_STUCCO',
  HARDBOARD: 'HARDBOARD',
  LIMESTONE: 'LIMESTONE',
  LOGS: 'LOGS',
  LOGS_CEDAR: 'LOGS_CEDAR',
  LOGS_DELUXE_HALFROUND: 'LOGS_DELUXE_HALFROUND',
  LOGS_DELUXE_HANDHEWN: 'LOGS_DELUXE_HANDHEWN',
  LOGS_DELUXE_OVERSIZED: 'LOGS_DELUXE_OVERSIZED',
  MARBLE: 'MARBLE',
  METAL_HORIZONTAL: 'METAL_HORIZONTAL',
  METAL_VERTICAL: 'METAL_VERTICAL',
  NEW_ENGLAND_SHINGLE: 'NEW_ENGLAND_SHINGLE',
  PINE: 'PINE',
  PLASTER: 'PLASTER',
  PLYWOOD: 'PLYWOOD',
  SANDSTONE: 'SANDSTONE',
  SLUMP_BLOCK: 'SLUMP_BLOCK',
  SPLIT_LOG: 'SPLIT_LOG',
  SPLIT_ROCK: 'SPLIT_ROCK',
  STEEL: 'STEEL',
  STONE: 'STONE',
  STONE_IMITATION: 'STONE_IMITATION',
  STONE_12: 'STONE_12',
  STONE_18: 'STONE_18',
  STONE_24: 'STONE_24',
  STONE_8: 'STONE_8',
  STONE_POLISHED_FACE: 'STONE_POLISHED_FACE',
  STONE_SAWN_FACE: 'STONE_SAWN_FACE',
  STONE_SEAM_FACE: 'STONE_SEAM_FACE',
  STONE_SPLIT_ROCK: 'STONE_SPLIT_ROCK',
  STUCCO: 'STUCCO',
  T111: 'T111',
  VICTORIAN_SCALLOPED_SHAKES: 'VICTORIAN_SCALLOPED_SHAKES',
  VINYL: 'VINYL',
  VINYL_HORIZONTAL: 'VINYL_HORIZONTAL',
  VINYL_VERTICAL: 'VINYL_VERTICAL',
  WOOD: 'WOOD',
  WOOD_IMITATION: 'WOOD_IMITATION',
  WOOD_LAP: 'WOOD_LAP',
  UNKNOWN: 'UNKNOWN'
};

const ELECTRICAL_JUNCTION_TYPES = {
  BREAKER: 'BREAKER',
  FUSEBOX: 'FUSEBOX'
};

const GARAGE_SHELTER_CONSTRUCTION_TYPES = {
  ATTACHED: 'ATTACHED',
  DETACHED: 'DETACHED',
  BASEMENT: 'BASEMENT',
  BUILT_IN: 'BUILT_IN'
};

const MASTER_CONDO_POLICY_TYPES = {
  BARE_WALLS_IN: 'BARE_WALLS_IN',
  ALL_IN: 'ALL_IN'
};

const UPDATE_TYPES = {
  FULL: 'FULL',
  PARTIAL: 'PARTIAL'
};

const PROPERTY_UPDATE_TYPE_OPTIONS = [
  {
    value: UPDATE_TYPES.FULL,
    label: 'Full'
  },
  {
    value: UPDATE_TYPES.PARTIAL,
    label: 'Partial'
  }
];

const FINALIZATION_TYPES = {
  CAN_IMPROVE: 'CAN_IMPROVE',
  CANT_IMPROVE: 'CANT_IMPROVE',
  JOURNEY_READY: 'JOURNEY_READY',
  CONVERT_TO_QUOTE: 'CONVERT_TO_QUOTE'
};

const ANNUAL_MILEAGE_RANGES = {
  ZERO_TO_THREE_THOUSAND: '0 - 3,000',
  THREE_TO_FIVE_THOUSAND: '3,001 - 5,000',
  FIVE_TO_EIGHT_THOUSAND: '5,001 - 8,000',
  EIGHT_TO_TEN_THOUSAND: '8,001 - 10,000',
  TEN_TO_TWELVE_THOUSAND: '10,001 - 12,000',
  TWELVE_TO_FIFTEEN_THOUSAND: '12,001 - 15,000',
  FIFTEEN_TO_TWENTY_THOUSAND: '15,001 - 20,000',
  TWENTY_TO_TWENTY_FIVE_THOUSAND: '20,001 - 25,000',
  TWENTY_FIVE_THOUSAND_PLUS: '25,000+'
};

const PROPERTY_DISCOUNTS = {
  SPRINKLERS: 'SPRINKLERS',
  SMOKE_DETECTOR: 'SMOKE_DETECTOR',
  DEADBOLT: 'DEADBOLT',
  FIRE_EXTINGUISHER: 'FIRE_EXTINGUISHER',
  SMOKE_FREE: 'SMOKE_FREE',
  DOOR_ATTENDANT: 'DOOR_ATTENDANT'
};

const EXCLUDED_DRIVER_REASONS = {
  NOT_LICENSED: 'NOT_LICENSED',
  INSURED_SEPARATELY: 'INSURED_SEPARATELY',
  MILITARY: 'MILITARY',
  OTHER: 'OTHER'
};

const LINE_OF_BUSINESS_TYPES = {
  HOME: 'HOME',
  CONDO: 'CONDO',
  RENTERS: 'RENTERS',
  LANDLORD_HOME: 'LANDLORD_HOME',
  LANDLORD_CONDO: 'LANDLORD_CONDO'
};

const CLAIMS_LOB = {
  PROPERTY: 'PROPERTY',
  AUTO: 'AUTO'
};

const UNINSURED_REASONS = {
  FIRST_CAR: 'FIRST_CAR',
  CAR_IN_STORAGE: 'CAR_IN_STORAGE',
  MILITARY: 'MILITARY',
  OTHER: 'OTHER'
};

const TORT_LIMITATION_OPTIONS = {
  LIMITED: 'LIMITED',
  FULL: 'FULL',
  OUT_OF_STATE: 'OUT_OF_STATE'
};

module.exports = {
  MASTER_CONDO_POLICY_TYPES,
  DRIVER_TYPE,
  DRIVER_USAGE,
  APPLICANT_TYPES,
  ADDRESS_TYPES,
  GENDER,
  DEFAULT_RELATIONSHIP,
  RELATIONSHIPS,
  MARITAL_STATUSES,
  PHONE_TYPES,
  DWELLING_TYPES,
  PROPERTY_TYPES,
  EDUCATION,
  RESIDENCE_TYPES,
  PLUMBING_TYPES,
  HOME_BUSINESS_TYPES,
  DOG_BREEDS,
  LICENSE_STATUS_OPTIONS,
  YEARS_INSURED,
  ALARM_SIGNAL_TYPES,
  STORM_PROTECTIONS,
  PROPERTY_INCIDENT_DESCS,
  INCIDENT_TYPES,
  PREFERRED_COMMUNICATION_METHODS,
  CLAIM_DESCRIPTIONS,
  VIOLATION_DESCRIPTIONS,
  ACCIDENT_DESCRIPTIONS,
  VEHICLE_OWNERSHIP_STATUS,
  VEHICLE_ACTIVITES,
  VEHICLE_USES,
  HEATING_SOURCES,
  FOUNDATION_TYPES,
  CONSTRUCTION_TYPES,
  ROOF_TYPES,
  ROOF_SHAPES,
  EXTERIOR_WALL_MATERIALS,
  ELECTRICAL_JUNCTION_TYPES,
  GARAGE_SHELTER_CONSTRUCTION_TYPES,
  ANIMALS,
  UPDATE_TYPES,
  PROPERTY_UPDATE_TYPE_OPTIONS,
  FINALIZATION_TYPES,
  DONT_KNOW,
  NEVER,
  ANNUAL_MILEAGE_RANGES,
  PROPERTY_DISCOUNTS,
  EXCLUDED_DRIVER_REASONS,
  LINE_OF_BUSINESS_TYPES,
  CLAIMS_LOB,
  UNINSURED_REASONS,
  TORT_LIMITATION_OPTIONS
};
